import { supabase } from "./supabaseClient";

const API_BASE = import.meta.env.VITE_API_BASE ?? "/api";

// The two adoption signals the worker can't see on its own: a
// volunteer leaving for MSP to request a sub, and a volunteer opening
// the help center. Everything else is observed server-side on the
// dashboard read (see worker/src/lib/volunteer-events.ts).
//
// Deliberately thin: no queue, no retry, no third-party SDK, no
// identifiers of our own. The worker derives parish and account from
// the bearer token, so this call carries no scope the caller could
// tamper with. Failures are swallowed — a missed count must never
// interrupt what the volunteer was doing.
export type ReportableEvent = "sub_requested" | "help_used";

export async function reportVolunteerEvent(
  event: ReportableEvent,
  topic?: string,
): Promise<void> {
  if (!supabase) return;
  try {
    const { data } = await supabase.auth.getSession();
    // No session = a signed-out visitor (e.g. the public help page).
    // We deliberately don't count those: instrumenting
    // unauthenticated pages is out of scope.
    if (!data.session) return;
    await fetch(`${API_BASE}/volunteer/events`, {
      method: "POST",
      cache: "no-store",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${data.session.access_token}`,
      },
      body: JSON.stringify(topic ? { event, topic } : { event }),
      // Survives the page teardown when the click navigates away to
      // MSP — without this the sub_requested beacon is racing the
      // unload and usually loses.
      keepalive: true,
    });
  } catch {
    // Intentionally silent.
  }
}
